import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-doctorform',
  templateUrl: './doctorform.component.html',
  styleUrls: ['./doctorform.component.css']
})
export class DoctorformComponent implements OnInit {
  title = "Doctor Details"
  dtOptions: any = {};
  ProductListt: any[] = [];
  mode: any;
  DOC_NOs: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  isSearch: boolean;
  data: any;
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  Hospital: any = [];
  HospitalData: any;
  QualificationData: any;
  Qualification: any = [];
  Designation: any = [];
  DesignationData: any;
  ClinicalDisciplineData: any;
  ClinicalDiscipline: any = [];
  Specialization: any = [];
  SpecializationData: any;
  StateData: any;
  State: any = [];
  District: any = [];
  DistrictData: any;
  D: any = {};
  DO_Id: number;
  fileToUpload: File;

  hide:any;
  formInvalid : boolean = false;
  numericpattern:any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) { }

  ngOnInit() {
    this.GetHospitalDropDown();
    this.GetQualificationDropDown();
    this.GetDesignationDropDown();
    this.GetClinicalDisciplineDropDown();
    this.GetSpecializationDropDown();
    this.GetStateDropDown();
    this.GetDistrictDropDown();

    this.route.params.subscribe(params => {
      this.DO_Id = params['DO_Id'];
      this.mode = params['mode'];

      if (this.DO_Id > 0) {

        this.GetByIdDoctorModel(this.DO_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Doctor ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Doctor ";
    }
  }

  GetHospitalDropDown() {
    this.HospitalData = this.userService.GetHospitalDropDown();
    this.HospitalData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.Hospital = Resp.Result;
      }
    )
  }

  GetQualificationDropDown() {
    this.QualificationData = this.userService.GetQualificationDropDown();
    this.QualificationData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.Qualification = Resp.Result;
      }
    )
  }

  GetDesignationDropDown() {
    this.DesignationData = this.userService.GetDesignationDropDown();
    this.DesignationData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.Designation = Resp.Result;
      }
    )
  }

  GetClinicalDisciplineDropDown() {
    this.ClinicalDisciplineData = this.userService.GetClinicalDisciplineDropDown();
    this.ClinicalDisciplineData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.ClinicalDiscipline = Resp.Result;
      }
    )
  }

  GetSpecializationDropDown() {
    this.SpecializationData = this.userService.GetSpecializationDropDown();
    this.SpecializationData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.Specialization = Resp.Result;
      }
    )
  }

  GetStateDropDown() {
    this.StateData = this.userService.GetStateDropDown();
    this.StateData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.State = Resp.Result;
      }
    )
  }

  GetDistrictDropDown() {
    this.DistrictData = this.userService.GetDistrictDropDown();
    this.DistrictData.subscribe(
      (Resp: any) => {
        console.log(Resp)
        this.District = Resp.Result;
      }
    )
  }

  CreateDoctorDetails(Doctor: NgForm) {
    debugger;
    this.data = this.userService.CreateDoctorDetails(Doctor.value);
    this.data.subscribe(
      (response) => {
        Doctor.reset();
        Doctor.resetForm();
        Doctor.form.markAsPristine();
        Doctor.form.markAsUntouched();
        swal('Success!', 'Doctor Details Added Successfully .', 'success');
        this.router.navigate(['/home/doctor']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  GetByIdDoctorModel(DO_Id) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdDoctorModel(DO_Id);
    this.data.subscribe(
      (response: any) => {
        this.D = response;
        if (this.D.DO_DOB != null)
          this.D.DO_DOB = ((this.D.DO_DOB).split('T'))[0];
      }, (error) => {
      });
  }

  UpdateDoctor(Doctor: NgForm) {
    debugger;
    //Doctor.value.DO_Photo = this.getimageUrl();
    this.data = this.userService.UpdateDoctor(this.DO_Id,Doctor.value);
    
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Doctor details updated Successfully .', 'success');
        this.router.navigate(['/home/doctor']);
      }, (error) => {
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }

  imageUpload(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;   
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData(); 
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImageRecovery(data);
          x.subscribe(
            (response) => {
            }, (error) => {
              let i: any = document.getElementById('DO_Photo');
              i.value = "";
              if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('DO_Photo');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }

      getimageUrl() {
        let imagename = null;
        try {
          imagename = document.getElementById('DO_Photo');
          return imagename.files[0].name;
        }
        catch (e) {
          return null; 
        }
      }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/doctor/doctorform/doctorform.component.ts